import * as api from '../api/recalculation';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN/RECALCULATE';

export const FETCH_ALL_JOBS = createRequestTypes(`${prefix}/FETCH_ALL_JOBS`);

export const CREATE_JOB = createRequestTypes(`${prefix}/CREATE_JOB`);

export const FETCH_JOB = createRequestTypes(`${prefix}/FETCH_JOB`);

export const FETCH_MARKET_AREA_CODES = createRequestTypes(
  `${prefix}/FETCH_MARKET_AREA_CODES`,
);

export const FETCH_CURRENT_APPRAISAL_YEAR = createRequestTypes(
  `${prefix}/FETCH_CURRENT_APPRAISAL_YEAR`,
);

export const FETCH_RECALC_JOB_ERRORS = createRequestTypes(
  `${prefix}/FETCH_RECALC_JOB_ERRORS`,
);

export const fetchAllJobs = makeApiActionCreatorV3(
  api.fetchAllJobs,
  FETCH_ALL_JOBS[START],
  FETCH_ALL_JOBS[SUCCESS],
  FETCH_ALL_JOBS[ERROR],
);

export const createJob = makeApiActionCreatorV3(
  api.createRecalcJob,
  CREATE_JOB[START],
  CREATE_JOB[SUCCESS],
  CREATE_JOB[ERROR],
);

export const fetchJob = makeApiActionCreatorV3(
  api.fetchRecalcJob,
  FETCH_JOB[START],
  FETCH_JOB[SUCCESS],
  FETCH_JOB[ERROR],
);

export const fetchMarketAreaCodes = makeApiActionCreatorV3(
  api.fetchMarketArea,
  FETCH_MARKET_AREA_CODES[START],
  FETCH_MARKET_AREA_CODES[SUCCESS],
  FETCH_MARKET_AREA_CODES[ERROR],
);

export const fetchCurrentAppraisalYear = makeApiActionCreatorV3(
  api.fetchCurrentAppraisalYear,
  FETCH_CURRENT_APPRAISAL_YEAR[START],
  FETCH_CURRENT_APPRAISAL_YEAR[SUCCESS],
  FETCH_CURRENT_APPRAISAL_YEAR[ERROR],
);

export const fetchRecalcJobErrors = makeApiActionCreatorV3(
  api.fetchRecalcJobErrors,
  FETCH_RECALC_JOB_ERRORS[START],
  FETCH_RECALC_JOB_ERRORS[SUCCESS],
  FETCH_RECALC_JOB_ERRORS[ERROR],
);